<div class="app__new-version-container">
  <span>{{ 'portal.new.version.available' | portalTranslate }}</span>

  <a (click.prevent)="reload()" href="#">
    {{ 'portal.new.version.available.action' | translate }}
  </a>
</div>

<portal-toasts></portal-toasts>

@if (portalContainer) {
  @if (show$ | async) {
    <portal-maintenance-messages *portalIsAuthorized="{ requiredUserLevel: UserLevel.EnterpriseAdmin }" />
    <portal-header />
    <portal-jump-to-command />
    <portal-log-level-command />
    <div class="app-body">
      <div>
        <portal-breadcrumbs class="portal-breadcrumbs"></portal-breadcrumbs>
        <main class="main" (click)="toggleMobileSidebar()">
          <portal-menu-container (click)="$event.stopPropagation()"></portal-menu-container>
          <div class="container-fluid">
            <ng-container *ngTemplateOutlet="elseTpl" />
          </div>
        </main>
      </div>
    </div>
  }
} @else {
  <ng-container *ngTemplateOutlet="elseTpl" />
}

@if (routerInitialized$ | async) {
  <portal-footer></portal-footer>
}

<ng-template #elseTpl>
  <ng-content></ng-content>
</ng-template>
